import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import { ConsumptionView } from "./consumption/Landing";
import EfficiencyTips from "./tips/EfficiencyTips";
import { useTranslation } from "react-i18next";

export const ConsumptionLanding=()=>{
     const { t } = useTranslation();
     const tabComponents = {
    consumption: {
      label: t("Consumption"),
      shortLabel: t("Consumption"),
      component: <ConsumptionView />
    },
    tips: {
      label: t("Tips"),
      shortLabel: t("Tips"),
      component: <EfficiencyTips />
    },
  };

  const urlMapping = {
    consumption: "consumption",
    tips: "tips", 
  };

     return (
 <div className="p-6 space-y-6">
  <PageHeader title={t("Consumption")} subtitle={t("Track your water usage and identify saving opportunities")}
  ></PageHeader>
 <Tabs 
        defaultValue="consumption"
        tabComponents={tabComponents}
        urlMapping={urlMapping}
        tabsListClassName="grid grid-cols-2 w-full"
        idPrefix="consumption-tab"
        className="space-y-4"
      />
  </div>
 );
}